$(function () {
    // https://github.com/burocratik/outdated-browser
    // Edge 16+ Supports [lowerThan: 'object-fit']  > IE11 not
    // For < IE11 use: [lowerThan: 'object-fit']
    var outdated = document.getElementById("outdated");

    this.defaultOpts = {
        bgColor: '#2b76a3',
        color: '#ffffff',
        lowerThan: 'borderImage',
        languagePath: '/public/assets/de.html'
    }

    // Open all Markdown-Links from external URL in new Tab
    $(document.links).filter(function () {
        return this.hostname != window.location.hostname;
    }).attr('target', '_blank');

});